import React from "react";

import { useSignups } from "Signups/state";
import { useMediaSettings } from "Signups/stateHooks";

import { SignupImage } from "./SignupImage";
import { SignupVideo } from "./SignupVideo";

export function ImageVideo() {
  const { mediaIsImage, mediaIsVideo } = useMediaSettings();

  if (mediaIsImage) {
    return <SignupImage />;
  }

  if (mediaIsVideo) {
    return <SignupVideo />;
  }

  return null;
}
